<script setup>
  /**
   * TransformErrorState — shared error panel for the Transform Learning views.
   * Shown when the store fails to load the catalogue/progress so a network/permission
   * failure surfaces an explicit, retryable message instead of an empty catalogue.
   */
  defineProps({
    message: { type: String, default: 'Something went wrong while loading this page.' },
  })
  const emit = defineEmits(['retry'])
</script>

<template>
  <div class="tes-root d-flex flex-column align-items-center justify-content-center text-center">
    <p class="header-20 mb-2"><strong>We couldn't load this page</strong></p>
    <p class="text-16 text-gray-700 mb-3">{{ message }}</p>
    <button type="button" class="btn btn-primary" @click="emit('retry')">Try again</button>
  </div>
</template>

<style scoped lang="scss">
  .tes-root {
    min-height: 320px;
    padding: 48px 16px;
  }
</style>
